document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('email-popup-modal');
  const closeButton = popup.querySelector('.email-popup-close');
  const overlay = popup.querySelector('.email-popup-overlay');
  
  // 1. Define the unique cookie name and how long until it expires
  const cookieName = 'first_visit_popup_seen';
  const expiryDays = 30; // The pop-up won't show again for 30 days

  // --- Helper Functions for Cookie Management ---

  // Function to get a cookie value
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // Function to set a cookie value
  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    // Set cookie path to '/' so it's accessible across the entire site
    document.cookie = `${name}=${value}${expires}; path=/`;
  }
  
  // --- Pop-up Display Logic ---

  // 2. Logic to hide the pop-up AND set the cookie
  function hidePopupAndSetCookie() {
    popup.classList.remove('email-popup-visible');
    // Set the cookie when the user closes the modal
    setCookie(cookieName, 'true', expiryDays); 
    // Optional: add class to body to prevent scrolling when closed
    document.body.classList.remove('popup-open'); 
  }

  // 3. Initial check and display
  function initializePopup() {
    // ONLY SHOW if the specific cookie is NOT set
    if (!getCookie(cookieName)) {
      setTimeout(() => {
        popup.classList.add('email-popup-visible');
        // Optional: add class to body to prevent scrolling when open
        document.body.classList.add('popup-open'); 
      }, 1500); // Show after a short delay (1.5 seconds) for better user experience
    }
  }

  // 4. Attach event listeners
  closeButton.addEventListener('click', hidePopupAndSetCookie);
  overlay.addEventListener('click', hidePopupAndSetCookie);

  // Start the process
  initializePopup();
});